export class Nutrition {
    Cal = 0;
    Fat = 0;
    Car = 0;
    Pro = 0;
    CalDiff = 0;
    FatDiff = 0;
    CarDiff = 0;
    ProDiff = 0;
    CalPlan = 0;
    FatPlan = 0;
    CarPlan = 0;
    ProPlan = 0;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/nutrition-model.ts